import type { ReactNode } from "react";

interface RightPanelProps {
  children: ReactNode;
}

export const RightPanel = ({ children }: RightPanelProps) => (
  <div
    className="hidden w-1/2 flex-col items-center justify-center px-12 py-8 lg:flex"
    style={{
      background: `
        radial-gradient(circle at top left, #4855bf 0%, rgba(28, 17, 68, 0) 40%),
        radial-gradient(circle at bottom right, #2c256f 0%, rgba(28, 17, 68, 0) 20%),
        linear-gradient(to bottom, #180e3a, #211450)
      `,
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}
  >
    <div className="w-full max-w-lg">{children}</div>
  </div>
);
